var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "button",
        {
          class: ((_obj = {}), (_obj[_vm.icon] = _vm.icon !== null), _obj),
          on: {
            click: function($event) {
              _vm.showModal = true
            }
          }
        },
        [
          _vm._v(
            "\n\t\t" +
              _vm._s(
                _vm.icon === null
                  ? _vm.t("health", "Add new {eName}", {
                      eName: _vm.entityName
                    })
                  : ""
              ) +
              "\n\t"
          )
        ]
      ),
      _vm._v(" "),
      _vm.showModal
        ? _c(
            "Modal",
            {
              attrs: { title: "add item" },
              on: {
                close: function($event) {
                  _vm.showModal = false
                }
              }
            },
            [
              _c("div", { staticClass: "modal__content" }, [
                _vm.inputMode === "add"
                  ? _c("h1", [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(
                            _vm.t("health", "Add new {entityName}", {
                              entityName: _vm.entityName
                            })
                          ) +
                          "\n\t\t\t"
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.inputMode === "edit"
                  ? _c("h1", [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(
                            _vm.t("health", "Edit {entityName}", {
                              entityName: _vm.entityName
                            })
                          ) +
                          "\n\t\t\t"
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "scrollable" },
                  _vm._l(_vm.header, function(h, index) {
                    return _c(
                      "div",
                      { key: index, class: { hide: !h.show, field: true } },
                      [
                        _vm.isNewSection(index)
                          ? _c("h2", [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(h.section.name) +
                                  "\n\t\t\t\t\t"
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("h3", [
                          _vm._v(
                            _vm._s("prefix" in h ? h.prefix : "") +
                              _vm._s(h.name) +
                              _vm._s("suffix" in h ? " [" + h.suffix + "]" : "")
                          )
                        ]),
                        _vm._v(" "),
                        "hint" in h
                          ? _c("div", { staticClass: "hint" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(h.hint) +
                                  "\n\t\t\t\t\t"
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        h.type === "date"
                          ? _c("div", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.values[h.columnId],
                                    expression: "values[h.columnId]"
                                  }
                                ],
                                staticClass: "widthfitcontent",
                                attrs: { type: "date" },
                                domProps: { value: _vm.values[h.columnId] },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.values,
                                      h.columnId,
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          : h.type === "datetime"
                          ? _c("div", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.values[h.columnId],
                                    expression: "values[h.columnId]"
                                  }
                                ],
                                staticClass: "widthfitcontent",
                                attrs: { type: "datetime-local" },
                                domProps: { value: _vm.values[h.columnId] },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.values,
                                      h.columnId,
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          : h.type === "select"
                          ? _c(
                              "div",
                              { staticClass: "wrapper" },
                              [
                                _c("Multiselect", {
                                  attrs: {
                                    options: h.options,
                                    "track-by": "id",
                                    label: "label"
                                  },
                                  model: {
                                    value: _vm.values[h.columnId],
                                    callback: function($$v) {
                                      _vm.$set(_vm.values, h.columnId, $$v)
                                    },
                                    expression: "values[h.columnId]"
                                  }
                                })
                              ],
                              1
                            )
                          : h.type === "multiselect"
                          ? _c(
                              "div",
                              { staticClass: "wrapper" },
                              [
                                _c("Multiselect", {
                                  attrs: { options: h.options, multiple: true },
                                  model: {
                                    value: _vm.values[h.columnId],
                                    callback: function($$v) {
                                      _vm.$set(_vm.values, h.columnId, $$v)
                                    },
                                    expression: "values[h.columnId]"
                                  }
                                }),
                                _vm._v(" "),
                                _vm.values[h.columnId]
                                  ? _c(
                                      "div",
                                      _vm._l(_vm.values[h.columnId], function(
                                        selection,
                                        i
                                      ) {
                                        return _c("div", { key: i }, [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t" +
                                              _vm._s(selection.label) +
                                              "\n\t\t\t\t\t\t\t"
                                          )
                                        ])
                                      }),
                                      0
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          : h.type === "longtext"
                          ? _c("div", [
                              _c("textarea", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.values[h.columnId],
                                    expression: "values[h.columnId]"
                                  }
                                ],
                                attrs: {
                                  placeholder:
                                    h.placeholder !== undefined
                                      ? h.placeholder
                                      : ""
                                },
                                domProps: { value: _vm.values[h.columnId] },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.values,
                                      h.columnId,
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          : h.type === "boolean"
                          ? _c("div", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.values[h.columnId],
                                    expression: "values[h.columnId]"
                                  }
                                ],
                                attrs: { id: h.columnId, type: "checkbox" },
                                domProps: {
                                  checked: Array.isArray(_vm.values[h.columnId])
                                    ? _vm._i(_vm.values[h.columnId], null) > -1
                                    : _vm.values[h.columnId]
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.values[h.columnId],
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.values,
                                            h.columnId,
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.values,
                                            h.columnId,
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(_vm.values, h.columnId, $$c)
                                    }
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("label", { attrs: { for: h.columnId } }, [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.values[h.columnId] &&
                                        _vm.values[h.columnId] === true
                                        ? h.textTrue
                                          ? h.textTrue
                                          : "On"
                                        : h.textFalse
                                        ? h.textFalse
                                        : "Off"
                                    ) +
                                    "\n\t\t\t\t\t\t"
                                )
                              ])
                            ])
                          : h.type === "number"
                          ? _c("div", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.values[h.columnId],
                                    expression: "values[h.columnId]"
                                  }
                                ],
                                staticClass: "widthfitcontent",
                                attrs: {
                                  type: "Number",
                                  min: "min" in h ? h.min : "",
                                  max: "max" in h ? h.max : ""
                                },
                                domProps: { value: _vm.values[h.columnId] },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.values,
                                      h.columnId,
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          : h.type === "text"
                          ? _c("div", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.values[h.columnId],
                                    expression: "values[h.columnId]"
                                  }
                                ],
                                staticClass: "widthfitcontent",
                                domProps: { value: _vm.values[h.columnId] },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.values,
                                      h.columnId,
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          : h.type === "calculate"
                          ? _c("div", [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm.t("health", "Will be calculated", {})
                                  ) +
                                  "\n\t\t\t\t\t"
                              )
                            ])
                          : _vm._e()
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c(
                  "button",
                  { staticClass: "primary", on: { click: _vm.sendData } },
                  [
                    _vm._v(
                      "\n\t\t\t\t" +
                        _vm._s(
                          _vm.t("health", "Send {eName}", {
                            eName: _vm.entityName
                          })
                        ) +
                        "\n\t\t\t"
                    )
                  ]
                ),
                _vm._v(" "),
                _c("button", { on: { click: _vm.closeModal } }, [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(_vm.t("health", "Cancel", {})) +
                      "\n\t\t\t"
                  )
                ])
              ])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }